import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HomeModule } from './features/home/home.module';
import { MaterialTestModule } from './features/material-test/material-test.module';

// import ngx-translate and the http loader
import { HttpClient, provideHttpClient } from '@angular/common/http';
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// import ngx-translate-messageformat-compiler
import { NgOptimizedImage } from '@angular/common';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import 'moment/locale/hu';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { NewCountryDialogModule } from './features/admin/admin-prices/new-country-dialog/new-country-dialog.module';
import { LoginModule } from './features/login/login.module';
import { RegisterForOwnerModule } from './features/register-for-owner/register-for-owner.module';
import { CookieManagerModule } from './shared/components/cookie-manager/cookie-manager.module';
import { OwnerMenuModule } from './shared/components/owner-menu/owner-menu.module';
import { EditDogBreedDialogModule } from './shared/dialogs/edit-dog-breed-dialog/edit-dog-breed-dialog.module';
import { EditEmailDialogModule } from './shared/dialogs/edit-email-dialog/edit-email-dialog.module';
import { FloatingProgressModule } from './shared/dialogs/floating-progress/gallery.module';
import { GalleryModule } from './shared/dialogs/gallery/gallery.module';
import { GeneralAlertDialogModule } from './shared/dialogs/general-alert-dialog/general-alert-dialog.module';
import { GeneralConfirmDialogModule } from './shared/dialogs/general-confirm-dialog/general-confirm-dialog.module';
import { NonMobileFeatureDialogModule } from './shared/dialogs/non-mobile-feature-dialog/non-mobile-feature-dialog.module';
import { NewsModule } from './shared/components/news/news.module';
import { AgePickerDialogModule } from './shared/dialogs/age-picker-dialog/age-picker-dialog.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HomeModule,
    LoginModule,
    RegisterForOwnerModule,
    MaterialTestModule,
    // ngx-translate and the loader module
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      // compiler configuration
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
    OwnerMenuModule,
    CookieManagerModule,
    GeneralAlertDialogModule,
    GeneralConfirmDialogModule,
    NonMobileFeatureDialogModule,
    EditEmailDialogModule,
    EditDogBreedDialogModule,
    MatProgressSpinnerModule,
    NgOptimizedImage,
    NewCountryDialogModule,
    MatButtonModule,
    GalleryModule,
    FloatingProgressModule,
    NewsModule,
    AgePickerDialogModule
  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(),
    provideMomentDateAdapter(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
